import { configApi } from 'api';
import { UserFeatureToggleType } from '../../reducers/userFeatureToggleReducer';

export const getFeatureToggles = async (): Promise<UserFeatureToggleType> => {
  const response = await configApi.getFeatureToggles();
  return response as UserFeatureToggleType;
};
